import GraficoLinhas from "../components/GraficoLinhas"
import api from "../components/api"
import { useQuery } from "@tanstack/react-query"


export default function TotalEmissoesPorMes(props: any) {


    const { cliente_id, ano } = props


    const { data } = useQuery({

        queryKey: ['dashboardEmissao', cliente_id, ano],
        queryFn: async () => {

            try {

                var dataPost = {

                    cliente_id,
                    ano,
                    

                }

                const result = await api.post('dashboardEmissao', dataPost)
                //console.log(result.data)
                return result.data ?? []


            } catch (err: any) {

                console.log(err.response)
                throw err

            }

        },
        enabled: !!cliente_id && !!ano

    })


    return (

        <div>


           <GraficoLinhas dataCharts={data ?? []} />

        </div>

    )

}